import { EmoticonWinkOutlineIcon } from './EmoticonWinkOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C8E56EC6-52DA-4BC7-81C0-1E5B14509086
 * name emoticon-wink-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-wink-outline.svg
 * tags
 * - Emoji 
 */
export const FaceWinkOutlineIcon = EmoticonWinkOutlineIcon;
export default FaceWinkOutlineIcon